import { useIntl } from "react-intl";
import { NotificationStatuses } from "~enums/notificationStatuses.ts";
import { ImportLogModal } from "~pages/Notifications/components/ImportNotificationItem/ImportLogModal.tsx";
import { NotificationItemBody } from "~pages/Notifications/components/NotificationItemBody.tsx";
import type { Notification } from "~types/notification.ts";

type Props = {
  notification: Notification;
};

export const ImportNotificationItem = ({ notification }: Props) => {
  const { formatMessage } = useIntl();

  const customButtons =
    [NotificationStatuses.Failed, NotificationStatuses.Completed].includes(notification.status as NotificationStatuses) &&
    notification?.data &&
    Object.keys(notification.data).length > 0
      ? [<ImportLogModal key="import.log.details" notification={notification} />]
      : [];

  return (
    <NotificationItemBody notification={notification} icon="fa-file-import" customButtons={customButtons}>
      {notification?.data?.Count && <div>{`${formatMessage({ id: "notification.import.count" })}: ${notification.data.Count}`}</div>}
      {notification?.data?.FailedCount && (
        <div>{`${formatMessage({ id: "notification.import.failedCount" })}: ${notification?.data?.FailedCount}`}</div>
      )}
    </NotificationItemBody>
  );
};
